import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify, tokens, Typography } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { Cluster } from '@cast/types';
import { isManagedByTerraform } from '@cast/utils';

import {
  getClustersQueryKey,
  getClusterQueryKey,
} from '@cast/shared-cluster-context-data-access';

export const useDeleteClusterMutation = (
  cluster: Cluster
): UseMutationResult<unknown, unknown, void, unknown> => {
  const queryClient = useQueryClient();
  const { name, id, managedBy } = cluster;
  const isTerraformManaged = isManagedByTerraform(managedBy);

  return useMutation({
    mutationFn: () => {
      return apiClient.clusters.deleteCluster({ clusterId: id });
    },
    onSuccess: () => {
      if (isTerraformManaged) {
        notify.success(
          <Typography variant="P14R">
            <Typography
              variant="P14R"
              color={tokens.theme.fg.status.success}
              component="span"
            >
              Cluster removed:
            </Typography>{' '}
            {name}
          </Typography>
        );
      }

      return Promise.all([
        queryClient.invalidateQueries({
          queryKey: getClustersQueryKey({}),
        }),
        queryClient.invalidateQueries({
          queryKey: getClusterQueryKey({ id }),
        }),
      ]);
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
